import {
  createBrowserRouter,
  RouterProvider,
  RouteObject as RouterDomObject,
} from 'react-router-dom';
import * as Sentry from '@sentry/react';
import AuthLayout from 'src/components/ui/layouts/auth-layout';
import { NotFoundPage } from 'src/pages';
import { routes } from 'src/routes/routes';
import { ProtectedRoute } from 'src/routes/protected-route';
import { RouteObject } from './routes.types';
import FullPageWrapper from 'src/containers/FullPageWrapper';

const builtRoutes = Object.keys(routes).map((key) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  const route = routes[key] as RouteObject;

  return {
    element: <ProtectedRoute route={route} />,
    errorElement: (
      <FullPageWrapper>
        <NotFoundPage />
      </FullPageWrapper>
    ),
    children: [
      {
        path: route.path,
        lazy: route.lazy,
        element: route.element,
        index: route.index,
        loader: route.loader,
        action: route.action,
      },
    ],
  };
}) as RouterDomObject[];

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter);

// Create router ONCE at module level to prevent recreation on every render (#2181)
// React Router warns against creating routers inside components as it causes
// full remounts and potential state loss on re-renders.
const router = sentryCreateBrowserRouter([
  {
    element: <AuthLayout />,
    errorElement: (
      <FullPageWrapper>
        <NotFoundPage />
      </FullPageWrapper>
    ),
    children: [
      {
        children: [...builtRoutes],
      },
    ],
  },
]);

const AppRoutes: React.FC = () => {
  return <RouterProvider router={router} />;
};

export default AppRoutes;
